import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";


export const am4ScrollbarXMixinLegacy = {
    methods: {
        // Setup Scrollbar For X-Axis
        am4SetupScrollbar(chart, isHeavyLoad, formatter, timezone) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            // Remove any current Scrollbars
            if (chart.scrollbarX) {
                chart.scrollbarX.dispose()
                chart.scrollbarX = null
            }

            let scrollbarX = null
            let scrollSeries1 = null
            if (isHeavyLoad) {
                scrollbarX = new am4core.Scrollbar();
                chart.scrollbarX = scrollbarX
            }
            else {
                let series = chart.series.getIndex(0)
                scrollbarX = new am4charts.XYChartScrollbar();
                scrollbarX.series.push(series);
                chart.scrollbarX = scrollbarX;
                chart.scrollbarX.scrollbarChart.plotContainer.filters.clear();
                chart.scrollbarX.background.fillOpacity = 1

                scrollSeries1 = chart.scrollbarX.chart.series.getIndex(0);
                scrollSeries1.filters.clear()
                scrollSeries1.strokeOpacity = 1

                chart.scrollbarX.scrollbarChart.dateFormatter = formatter
                let xAxes = chart.scrollbarX.scrollbarChart.xAxes.getIndex(0)
                xAxes.timezone = timezone
            }
            return {
                scrollBar: chart.scrollbarX,
                scrollSeries: scrollSeries1,
            }
        },

        _am4ChartInvalid(chart) {
            return _.isNil(chart)
        }
    },
}